module.exports = __webpack_public_path__ + "img/changeProfile-2@2x.01e964f.png";